import { FC } from 'react';
import { Link } from '@tanstack/react-router';
import { ChevronRight } from 'lucide-react';
import { useBreadcrumbs } from '@new/common/hooks/useBreadcrumbs';

export const Breadcrumb: FC = () => {
  const crumbs = useBreadcrumbs();

  if (crumbs.length <= 1) {
    return null;
  }

  return (
    <div className="flex flex-wrap items-center gap-2 p-6 lg:p-8">
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1;

        return (
          <div key={`${crumb.path}-${index}`} className="flex items-center gap-2 min-w-0">
            {isLast ? (
              <span className="l4 text-(--neutral-black-NB600) wrap-break-word min-w-0">
                {crumb.label}
              </span>
            ) : (
              <Link
                to={crumb.path}
                className="l4 text-(--neutral-black-NB600)! hover:text-(--primary-O900)! no-underline! transition-colors wrap-break-word min-w-0"
              >
                {crumb.label}
              </Link>
            )}
            {!isLast && (
              <ChevronRight size={16} className="text-(--neutral-black-NB400) shrink-0" />
            )}
          </div>
        );
      })}
    </div>
  );
};
